import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { BrandProvider } from './contexts/BrandContext';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Chat from './pages/Chat';
import Parts from './pages/Parts';
import Diagrams from './pages/Diagrams';
import AR from './pages/AR';
import Projects from './pages/Projects';
import Upgrade from './pages/Upgrade';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

export default function App() {
  return (
    <BrandProvider>
      <AuthProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/parts" element={<Parts />} />
              <Route path="/diagrams" element={<Diagrams />} />
              <Route path="/ar" element={<AR />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/upgrade" element={<Upgrade />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />

              {/* Catch-all: Redirect to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </Router>
      </AuthProvider>
    </BrandProvider>
  );
}
